import styled from 'styled-components';
import { colors, font } from '@chegg-ui/theme';
import { Font } from '../common/styled/common';
var family = font.family,
  size = font.size,
  weight = font.weight;
var white = colors.white;
export var VerifyAddressContainer = styled.div.withConfig({
  componentId: "sc-1t3lrg7-0"
})(["", ";margin-top:15px;p{display:block;background:", ";padding-top:10px;margin:0;}fieldset{margin-top:15px;}"], Font, white);
export var StyledText = styled.div.withConfig({
  componentId: "sc-1t3lrg7-1"
})(["font-family:", ";font-size:", ";padding-bottom:5px;font-weight:", ";"], family.aspira, size.px16, weight.heavy);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/internals/VerifyAddress/styled.js
// module id = 4550
// module chunks = 11